/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/**
 * Status constants for bulk actions in the dashboard UI
 *
 * This file contains constants for all status values used across bulk publish and export operations.
 * It allows consistent handling of status values across the application.
 */

export const PUBLISH_STATUS = {
  FAILURE: 'FAILURE',
  FAILED: 'FAILED',
  FAILED_TO_PUBLISH: 'FAILED_TO_PUBLISH',
  PENDING: 'PENDING',
  QUEUED: 'QUEUED',
  IN_PROGRESS: 'IN_PROGRESS',
  DELIVERED: 'DELIVERED'
};

export const EXPORT_STATUS = {
  ERROR: 'error',
  FAILED: 'failed',
  QUEUED: 'queued',
  IN_PROGRESS: 'processing',
  COMPLETE: 'complete'
};

export const BULK_PUBLISH_C6_STATUS = {
  FAILED: 'FAILED',
  DELIVERED: 'DELIVERED',
  NOT_STARTED: 'NOT-STARTED'
};

// UI status values (displayed to users)
export const BULK_UI_STATUS = {
  ERROR: 'Error',
  FAILED: 'Failed',
  PROCESSING: 'Processing',
  QUEUED: 'Queued',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed'
};

export const BULK_EXPORT_UI_STATUS = {
  ERROR: 'Error',
  PROCESSING: 'Processing',
  QUEUED: 'Queued',
  COMPLETED: 'Completed'
};

export const BULK_PUBLISH_POST_C6_UI_STATUS = {
  FAILED: 'Failed',
  DELIVERED: 'Delivered',
  NOT_STARTED: 'Not Started'
};

export const bulkActionFieldNames = {
  EXPORT_INITIATE_TIME: 'exportInitiateTime',
  PUBLISH_INITIATE_TIME: 'publishInitiateTime',
  START_TIME: 'startTime',
  END_TIME: 'endTime'
};

export const STATUS_TYPES = {
  PUBLISH: 'publish',
  EXPORT: 'export'
};
